import * as React from 'react'
import dayjs from 'dayjs'
import type { AnnouncementItemCardProps } from './AnnouncementItem.types'
import { cn } from '@core/utils'
import Icon from '../Icon/Icon'

const AnnouncementItemCard: React.FC<AnnouncementItemCardProps> = ({
    icon = 'announcement',
    title,
    description,
    datetime,
    layoutLeftClassName,
    layoutLeftProps,
    iconProps,
    layoutRightClassName,
    layoutRightProps,
    titleClassName,
    titleProps,
    descriptionClassName,
    descriptionProps,
    datetimeClassName,
    datetimeProps,
    className,
    ...props
}) => {
    return (
        <button
            type="button"
            className={cn(
                'flex w-full items-start gap-3 rounded-[13px] border border-semantic-background-tertiary p-4',
                className,
            )}
            {...props}>
            <div
                className={cn(
                    'grid size-10 shrink-0 place-items-center rounded-xl bg-solid-yellow-2',
                    layoutLeftClassName,
                )}
                {...layoutLeftProps}>
                <Icon name={icon} size={20} {...iconProps} />
            </div>
            <div
                className={cn(
                    'flex h-full flex-col text-left',
                    layoutRightClassName,
                )}
                {...layoutRightProps}>
                <h3
                    className={cn(
                        'mb-1 text-pretty !text-body-lg-b text-semantic-content-ink',
                        titleClassName,
                    )}
                    {...titleProps}>
                    {title}
                </h3>
                <p
                    className={cn(
                        'mb-2 line-clamp-3 !text-body-md-r text-semantic-content-ink',
                        descriptionClassName,
                    )}
                    dangerouslySetInnerHTML={{ __html: description }}
                    {...descriptionProps}
                />
                <span
                    className={cn(
                        'mt-auto !text-body-sm-r text-semantic-content-inkLight',
                        datetimeClassName,
                    )}
                    {...datetimeProps}>
                    {dayjs(datetime).format('DD MMM • HH:mm')}
                </span>
            </div>
        </button>
    )
}

AnnouncementItemCard.displayName = 'AnnouncementItemCard'

export default AnnouncementItemCard
